import { fetchWithCache } from "./fetchWithCache";

export const translate = async ({
  value,
  languageCode = "en",
}: {
  value: string[];
  languageCode?: any;
}): Promise<string[]> => {
  const domain =
    (process.env.REACT_APP_TRANSLATION_URL as string) ||
    "https://translations.stemscopes-v3.stemscopes-v4-dev.aws.acceleratelearning.com/api/graphql";

  try {
    const data = await fetchWithCache(domain, {
      method: "POST",
      credentials: "include",
      cacheTTL: 10 * 60 * 1000 * 60, // 10 hours
      headers: {
        "Content-Type": "application/json",
        Authorization: localStorage.getItem("token") as string,
      },
      body: JSON.stringify({
        query: `query getTranslations(
            $texts: [String!]
            $languageCode: String!
            $service: TranslationService
          ) {
            translateTexts(texts: $texts, languageCode: $languageCode, service: $service)
          }`,
        variables: {
          texts: value,
          languageCode,
          service: "GoogleGemini",
        },
      }),
    });

    if (data?.extensions?.code || data?.errors?.length) {
      throw new Error(
        `API error: ${
          data.extensions.code ||
          data.errors.map((e: any) => e.message).join("; ")
        }`,
      );
    }

    return data?.data?.translateTexts;
  } catch (e) {
    return value;
  }
};
